import React, { useState } from "react";
import { format, addDays, endOfMonth, differenceInDays } from "date-fns";
import "../CSS/horizontalDatePicker.css";
import { Icon } from "@iconify/react/dist/iconify.js";

const HorizontalDatePicker = ({ onDateSelect }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const lastDateOfMonth = endOfMonth(today);
  const totalDays = differenceInDays(lastDateOfMonth, today) + 1;

  const visibleDays = Math.min(5, totalDays);
  const [startIndex, setStartIndex] = useState(0);
  const [selectedDate, setSelectedDate] = useState(today);

  const allDates = Array.from({ length: totalDays }, (_, i) =>
    addDays(today, i)
  );
  function formatDateToIST(date) {
    // Convert to IST by adding 5 hours and 30 minutes
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(date.getTime() + istOffset);

    const day = istDate.getDate();
    const month = istDate.toLocaleString("default", { month: "long" });
    const year = istDate.getFullYear();

    // Add ordinal suffix to day
    const getOrdinal = (n) => {
      if (n > 3 && n < 21) return n + "th"; // 4th to 20th
      switch (n % 10) {
        case 1:
          return n + "st";
        case 2:
          return n + "nd";
        case 3:
          return n + "rd";
        default:
          return n + "th";
      }
    };

    return `${getOrdinal(day)} ${month} ${year}`;
  }

  const handlePrev = () => {
    setStartIndex(Math.max(startIndex - visibleDays, 0));
  };

  const handleNext = () => {
    setStartIndex(Math.min(startIndex + visibleDays, totalDays - visibleDays));
  };

  const handleDateClick = (date) => {
    setSelectedDate(date);
    onDateSelect?.(formatDateToIST(date));
  };

  return (
    <div className="text-center">
      <div className="d-flex justify-content-between align-items-end">
        <div>
          <p className="metropolis-medium">{format(today, "MMMM yyyy")}</p>
        </div>
        <div className="d-flex mb-3" style={{ gap: "0.6em" }}>
          <div
            className="btn btn-outline-secondary"
            onClick={handlePrev}
            disabled={startIndex === 0}
          >
            <Icon
              icon="ic:twotone-keyboard-arrow-left"
              width="20"
              height="20"
            />
          </div>
          <div
            className="btn btn-outline-secondary"
            onClick={handleNext}
            disabled={startIndex >= totalDays - visibleDays}
          >
            <Icon
              icon="ic:twotone-keyboard-arrow-right"
              width="20"
              height="20"
            />
          </div>
        </div>
      </div>

      <div className="d-flex align-items-center justify-content-start">
        <div className="date-scroll-wrapper d-flex justify-content-start">
          {allDates
            .slice(startIndex, startIndex + visibleDays)
            .map((date, index) => {
              const isSelected =
                format(date, "yyyy-MM-dd") ===
                format(selectedDate, "yyyy-MM-dd");
              return (
                <div
                  key={index}
                  className={`date-card border rounded mx-1 p-2 text-center ${
                    isSelected ? "selected-date" : ""
                  }`}
                  onClick={() => handleDateClick(date)}
                  style={{ cursor: "pointer" }}
                >
                  <div className="day fw-bold">
                    <small>{format(date, "EEE")}</small>
                  </div>
                  <div className="date fs-5">
                    <small>{format(date, "dd")}</small>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

export default HorizontalDatePicker;
